import axios, { AxiosInstance } from 'axios'
import { Endpoint } from 'Constants/endpoint'

const apiRequest = (): AxiosInstance =>
  axios.create({
    baseURL: Endpoint,
  })

export default apiRequest
